import { Component, EventEmitter } from '@angular/core';
import { CustomSelectComponent } from 'components/input/custom-select/custom-select.component';
import { CredentialType } from 'enums/CredentialType';
import { OnHoldReason } from 'enums/OnHoldReason';
import { SelectListItemModel } from 'models/SelectList';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { InvoicingService } from 'services/invoicing.service';
import { CredentialRequired } from 'services/credential.service';
import { NavigationService } from 'services/navigation.service';

@CredentialRequired(CredentialType.EditInvoiceOnHoldStatus)
@Component({
	templateUrl: './set-invoice-on-hold.component.html',
	imports: [Layout, CustomSelectComponent, TranslatePipe]
})
export class SetInvoiceOnHoldComponent {
	brandId?: string;
	documentNo?: string;
	companyId?: string;
	onHoldReasonEnum = OnHoldReason;
	onHoldReason?: OnHoldReason;
	onHoldReasons = Array.from(OnHoldReason.getKeys()).map(reason => new SelectListItemModel(reason[0], this.translate.transform('invoice.on-hold.reason.' + reason[1])));

	statusChanged = new EventEmitter<void>();

	constructor(private readonly invoicingService: InvoicingService,
		private readonly navigationService: NavigationService,
		private readonly translate: TranslatePipe) { }

	updateStatus() {
		if (!this.brandId || !this.documentNo || !this.companyId) return;
		this.invoicingService.updateOnHold(this.brandId, this.documentNo, this.companyId, this.onHoldReason!).then(() => {
			this.statusChanged.emit();
			this.navigationService.closeView(this);
		});
	}
}
